import { useCallback, useEffect, useState } from 'react';
import IconBack from '../../../assets/Images/icons/icon-back';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import { Form, Spin, Tag } from 'antd';
import FormBreach from './components/Form';
import PreviewForm from '../../../components/forms/preview';
import Customize from '../../../components/forms/preview/Customize';
import StepWizard from 'react-step-wizard';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import useDsBreach from './hooks/useDsBreach';
import { Events, scroller } from 'react-scroll';

import fullTemplate from './fullTemplate.json';
import initStyle from './initStyle.json';
import init from './init.json';
import useQuery from '../../../util/useQuery';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import { useTranslation } from 'react-i18next';
import { textOnly } from '../../../util/util';
import { useBlocker } from '../../../util/usePrompt';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import MenuBar from './components/MenuBar';
import usePermission from '../../../hooks/usePermission';

export default function EditForm() {
    const { isAuditor } = usePermission();
    const { t } = useTranslation();
    let navigate = useNavigate();
    const { id } = useParams();
    const params = useQuery();
    const formId = params.get('id');

    const [state, setState] = useState();

    const setInstance = (SW) => {
        setState({
            ...state,
            SW,
        });
    };

    const [form] = Form.useForm();
    const [formStyle] = Form.useForm();
    const style = Form.useWatch('style', formStyle);

    const [isPreviewMode, setIsPreviewMode] = useState(false);
    const [isCustomize, setIsCustomize] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [isCheckQuetions, setIsCheckQuetions] = useState(false);

    ///Discard change

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const {
        dsBreachDetail,
        loading,
        dsBreachTemplate,
        getMasterDataBreachTemplate,
        updateDataBreachForm,
        getDataBreachFormById,
    } = useDsBreach({ isPreview: false });

    const initGroup = {
        id: uuidv4(),
        partName: '',
        partDescription: '',
        skipToPart: null,
        groupQuestion: [],
    };

    useEffect(() => {
        if (isAuditor) {
            navigate(ROUTER.DATA_BREACH.FORM);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuditor]);

    useEffect(() => {
        if (id === 'new') {
            const json = init;
            json.part = [initGroup];
            form.setFieldsValue(json);
            formStyle.setFieldsValue(initStyle);
            setTimeout(() => {
                setChange(false);
                setOpenChange(false);
            }, 300);
        }
        if (id === 'edit') {
            if (formId && dsBreachDetail?.jsonData) {
                const jsonData = JSON.parse(dsBreachDetail?.jsonData || '{}');
                form.setFieldsValue(jsonData);
                if (dsBreachDetail?.style) {
                    formStyle.setFieldsValue({
                        style: dsBreachDetail?.style,
                    });
                }
                return;
            } else {
                form.setFieldsValue(fullTemplate);
                formStyle.setFieldsValue(initStyle);
            }
            setTimeout(() => {
                setChange(false);
                setOpenChange(false);
            }, 300);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dsBreachDetail, id, formId]);

    useEffect(() => {
        if (formId) getDataBreachFormById(formId);
    }, [getDataBreachFormById, formId]);

    useEffect(() => {
        getMasterDataBreachTemplate();
    }, [getMasterDataBreachTemplate]);

    const scrollToWithContainer = useCallback((id) => {
        const goToContainer = new Promise((resolve) => {
            Events.scrollEvent.register('end', () => {
                resolve();
                Events.scrollEvent.remove('end');
            });

            scroller.scrollTo('form-breach', {
                duration: 300,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        });

        goToContainer.then(() =>
            scroller.scrollTo(id, {
                duration: 300,
                delay: 0,
                smooth: 'easeInOutQuart',
                containerId: 'form-breach',
                offset: -100,
            })
        );
    }, []);

    const onFinishFailed = useCallback(
        ({ errorFields, values }) => {
            const part = values.part;
            const error = errorFields[0];
            const names = error.name;

            if (!names) return;

            const partIndex = names[1];
            const questionIndex = names[3];

            if (names.length === 3) {
                const id = part[partIndex].id;
                scrollToWithContainer(id);
            } else {
                const id = part[partIndex].groupQuestion[questionIndex].id;
                scrollToWithContainer(id);
            }
        },
        [scrollToWithContainer]
    );

    const resetChange = () => {
        setChange(false);
        setOpenConfirm(false);
    };

    const onFinish = useCallback(
        async (isPublish) => {
            setIsCheckQuetions(isPublish);
            try {
                const values = await form.validateFields();
                const isQuestionChecked = (key) => {
                    return values.part?.some(isGroupQuestionChecked(key));
                };

                const isGroupQuestionChecked = (key) => (group) => {
                    return group?.groupQuestion?.some(
                        isItemStoryIdChecked(key)
                    );
                };

                const isItemStoryIdChecked = (key) => (item) => {
                    return item.storyId === key;
                };

                const isAllChecked = dsBreachTemplate?.every((item) => {
                    if (!item.required) return true;
                    return isQuestionChecked(item.value);
                });
                if (isPublish) {
                    if (!isAllChecked) {
                        resetChange();
                        return;
                    }
                }

                const payload = {
                    dataBreachName: textOnly(values.formName),
                    jsonData: JSON.stringify(values),
                    isPublish,
                    style,
                    ...(formId && {
                        dataBreachFormId: dsBreachDetail?.dataBreachFormId,
                        dataBreachGroupId: dsBreachDetail?.dataBreachGroupId,
                    }),
                };

                const action = (id) => {
                    getDataBreachFormById(id);
                    resetChange();
                };
                updateDataBreachForm(payload, action);
            } catch (error) {
                resetChange();
                onFinishFailed(error);
            }
        },
        [
            dsBreachDetail?.dataBreachFormId,
            dsBreachDetail?.dataBreachGroupId,
            dsBreachTemplate,
            form,
            formId,
            getDataBreachFormById,
            onFinishFailed,
            style,
            updateDataBreachForm,
        ]
    );

    const getNextVersion = () => {
        const version = dsBreachDetail?.version || '0000.0';
        const majorVersion = parseInt(version.split('.')[0], 10) + 1;
        return majorVersion.toString().padStart(4, '0') + '.0';
    };

    useEffect(() => {
        return () => {
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
    }, []);

    return (
        <div>
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(ROUTER.DATA_BREACH.FORM);
                    }}
                >
                    <IconBack />
                </button>
                <span>แบบฟอร์มแจ้งเหตุละเมิดข้อมูลส่วนบุคคล</span>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    Data Breach / Data Breach Form /
                </span>
                <span> Edit Data Breach Form</span>
            </div>
            <Spin spinning={loading}>
                <StepWizard isHashEnabled={false} instance={setInstance}>
                    <Form
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                        form={form}
                        layout="vertical"
                    >
                        <MenuBar
                            isPreviewMode={isPreviewMode}
                            setIsPreviewMode={setIsPreviewMode}
                            setIsCustomize={setIsCustomize}
                            state={state}
                            dsBreachDetail={dsBreachDetail}
                            loading={loading}
                            onFinish={onFinish}
                            setOpenConfirm={setOpenConfirm}
                        />
                        <FormBreach
                            isCheckQuetions={isCheckQuetions}
                            dsBreachTemplate={dsBreachTemplate}
                        />
                    </Form>
                    <div hidden={!isPreviewMode} className="flex">
                        {isPreviewMode && (
                            <div className="w-full pt-6">
                                <MenuBar
                                    isPreviewMode={isPreviewMode}
                                    setIsPreviewMode={setIsPreviewMode}
                                    setIsCustomize={setIsCustomize}
                                    state={state}
                                    dsBreachDetail={dsBreachDetail}
                                    loading={loading}
                                    onFinish={onFinish}
                                    setOpenConfirm={setOpenConfirm}
                                />
                                <div
                                    className={classNames('outer dark', {
                                        '!rounded-r-none': isCustomize,
                                        '!rounded-none': !isCustomize,
                                    })}
                                >
                                    <div className="dot red" />
                                    <div className="dot amber" />
                                    <div className="dot green" />
                                </div>
                                <div
                                    style={{
                                        backgroundColor:
                                            style?.backgroundColor || '#EDEEF9',
                                    }}
                                    className="w-full h-[80vh] overflow-auto"
                                >
                                    <PreviewForm
                                        justPreview
                                        style={style}
                                        part={form.getFieldsValue([
                                            'formName',
                                            'formDescription',
                                            'part',
                                        ])}
                                    />
                                </div>
                            </div>
                        )}
                        <div hidden={!isCustomize} className="w-100">
                            <div className="outer dark">
                                <div className="dot red" />
                                <div className="dot amber" />
                                <div className="dot green" />
                            </div>
                            <Form
                                form={formStyle}
                                layout="vertical"
                                className="h-full"
                                onFieldsChange={(_, allFields) => {
                                    if (allFields.length > 0) {
                                        setChange(true);
                                    }
                                }}
                            >
                                <Customize
                                    handleClose={() => {
                                        setIsCustomize(false);
                                        setIsPreviewMode(false);
                                        state.SW.goToStep(1);
                                    }}
                                />
                            </Form>
                        </div>
                    </div>
                </StepWizard>
            </Spin>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => {
                    setOpenConfirm(false);
                }}
                loading={loading}
                handelOk={() => onFinish(true)}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            เผยแพร่แบบฟอร์ม ?
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            เผยแพร่เป็นเวอร์ชัน:{' '}
                            {dsBreachDetail?.version
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </div>
    );
}
